<template>
  <div class="sorting float-left mr-5" v-if="response && response.numFound">
    <b-dropdown
      id="sorting"
      :text="$t('sorting.sorting_by')"
      size="sm"
      v-if="sorting"
    >
      <b-dropdown-item
        v-on:click.prevent="sortingChanged(sorting.sem_action.sem_url_action)"
        class="bg-light"
        >{{ $t("sorting.relevancy") }}</b-dropdown-item
      >

      <template v-for="(field, key) in sorting.fields">
        <b-dropdown-item
          v-for="(fvalue, fkey) in field"
          :key="fkey + '_' + key"
          v-on:click.prevent="sortingChanged(fvalue.sem_url_action)"
          :active="fvalue.active && fvalue.active == true"
        >
          {{ $t(key) }}
          <v-icon v-if="fkey == 'asc'" name="arrow-up" class="vicon"></v-icon>
          <v-icon
            v-if="fkey == 'desc'"
            name="arrow-down"
            class="vicon"
          ></v-icon>
        </b-dropdown-item>
      </template>
    </b-dropdown>
    <b-button
      v-b-modal.exportoffice
      class="ml-1"
      variant="dark"
      size="sm"
      @click="$store.state.modalError = ''"
    >
      Export <v-icon name="list" class="vicon"></v-icon>
    </b-button>
    <b-button v-b-modal.sharebyemail class="ml-1" variant="dark" size="sm">
      Share <v-icon name="share-2" class="vicon"></v-icon>
    </b-button>
    <ExportToOfficeOrPDF></ExportToOfficeOrPDF>
    <ShareByEmail></ShareByEmail>
  </div>
</template>

<script>
import ExportToOfficeOrPDF from "./ExportToOfficeOrPDF";
import ShareByEmail from "./ShareByEmail";

export default {
  name: "sorting",
  components: {
    ExportToOfficeOrPDF,
    ShareByEmail,
  },
  methods: {
    sortingChanged: function(action) {
      this.$router.push(action);
    },
  },
  computed: {
    response() {
      return this.$store.state.response
        ? this.$store.state.response.response
        : null;
    },
    authenticated() {
      return this.$store.state.authenticated;
    },
    results() {
      if (
        this.$store.state.response &&
        this.$store.state.response.response &&
        this.$store.state.response.response.docs
      ) {
        return this.$store.state.response.response.docs;
      }
      return null;
    },
    sorting() {
      if (this.$store.state.response && this.$store.state.response.sorting) {
        return this.$store.state.response.sorting;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.dropdown-item.active {
  background-color: #41b883;
}
</style>
